import React from "react";

export const LinkedInIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3333 0.0351562C22.0406 0.0351563 22.7189 0.316108 23.219 0.816205C23.719 1.3163 24 1.99458 24 2.70182V21.3685C24 22.0757 23.719 22.754 23.219 23.2541C22.7189 23.7542 22.0406 24.0352 21.3333 24.0352H2.66667C1.95942 24.0352 1.28115 23.7542 0.781048 23.2541C0.280951 22.754 0 22.0757 0 21.3685V2.70182C0 1.99458 0.280951 1.3163 0.781048 0.816205C1.28115 0.316108 1.95942 0.0351563 2.66667 0.0351562H21.3333ZM20.6667 20.7018V13.6352C20.6667 12.4823 20.2087 11.3768 19.3936 10.5616C18.5784 9.74644 17.4728 9.28849 16.32 9.28849C15.1867 9.28849 13.8667 9.98182 13.2267 11.0218V9.54182H9.50667V20.7018H13.2267V14.1285C13.2267 13.1018 14.0533 12.2618 15.08 12.2618C15.5751 12.2618 16.0499 12.4585 16.3999 12.8086C16.75 13.1586 16.9467 13.6334 16.9467 14.1285V20.7018H20.6667ZM5.17333 7.44849C5.76742 7.44849 6.33717 7.21249 6.75725 6.79241C7.17733 6.37233 7.41333 5.80257 7.41333 5.20849C7.41333 3.96849 6.41333 2.95516 5.17333 2.95516C4.57571 2.95516 4.00257 3.19256 3.57999 3.61514C3.1574 4.03772 2.92 4.61087 2.92 5.20849C2.92 6.44849 3.93333 7.44849 5.17333 7.44849ZM7.02667 20.7018V9.54182H3.33333V20.7018H7.02667Z"
        fill="#686677"
      />
    </svg>
  );
};
